/**
 * @ignore
 */
const GeometryUtil=require('../../../utils/GeometryUtil');
const g2=require('../../../g2');
const BufferDragTool = g2.interact.Tool.extend({
    initialize: function (opt) {
        var opts = opt || {};
        g2.interact.Tool.call(this, opts);
        this.onMove = -1;
        this.currentElement = null;
        this.geometry = opts.geometry;
        this.map = opts.map;
        this.drawLayer = opts.drawLayer;
        this.lineEle = opts.lineEle;
        this.closeEle = opts.closeEle,
        this.picEle = opts.picEle;
        this.bufferEle = opts.bufferEle;
        this.maxPoint = opts.maxPoint;
        this.bufferMaxPoint = opts.bufferMaxPoint;
        this.callback = opts.callBack;
        this.context = opts.context;
        this.parent = opts.parent;
        this.textEle = opts.textEle;
        this.fillSymbol = opts.fillsymbol;
        //标注位置
        this.textPosition = opts.textPosition;
    },
    onMouseUp: function (button, shift, screenx, screeny, mapx, mapy, handled) {
        this.map.resumeDragPan();
        if (this.onMove == 0) {
            this.onMove = -1;
        } else if (this.onMove > 0) {
            var self = this;
            if(self.callback){
                self.callback.call(self.context, this.bufferGeoJSON, this.textlength, true);
            }
            this.onMove = -1;
            this.currentElement = null;
            this.drawLayer.update(this.picEle, true);
        }
    },
    onMouseDown: function (button, shift, screenx, screeny, mapx, mapy, handled) {
        if (this.onMove < 0) {
            var graphic = this.drawLayer.hitTest(screenx, screeny);

            if (graphic) {
                var _geom = graphic.element.geometry;
                if (!(_geom.x&&_geom.y)) {return};
                if (graphic.element.tag === "drag") {                
                    this.map.stopDragPan();
                    if (!!graphic && this.picEle.id == graphic.element.id) {
                        this.currentElement = graphic.element;
                        this.onMove++;
                        //this.drawLayer.update(this.picEle,true);
                    }
                }
            }
        }
    },
    onMouseMove: function (button, shift, screenx, screeny, mapx, mapy, handled) {
        //计算缓冲后geojson
        var _getBufferGeoJson=function(geojson,radius,srid){
            const bufferGeom = G.utils.SpatialOPUtil.getBuffer({
                geometry: geojson,
                radius: parseFloat(radius),
                spatialReference: srid,
            });
            return bufferGeom;
        };
        if (this.onMove >= 0) {
            if (!!this.currentElement) {
                var point1 = this.maxPoint;
                var point2 = new g2.sfs.Point({
                    x: mapx,
                    y: mapy,
                    spatialReference: this.map.spatialReference
                })
                var polyline = new g2.sfs.Polyline({
                    spatialReference: this.map.spatialReference
                });
                var path = new g2.sfs.Path({
                    spatialReference: this.map.spatialReference
                });
                path.addPoint(point1);
                path.addPoint(point2);
                polyline.addGeometry(path);
                this.lineEle.geometry = polyline;
                this.closeEle.geometry = point2;
                //缓冲面
                this.radius = Math.abs(point1.x - point2.x);

                // //将几何对象转为网络墨卡托米制坐标，兼容地理坐标与投影坐标
                // var _transformer = new g2.sfs.CoordinateTransform(); 
                // var _originalGeomTransformed = _transformer.transform(this.lineEle.geometry,3857);
                // //g2计算长度有偏差，改用jsts原生计算方式
                // var jstsGeom = GeometryUtil.toJstsGeometry(_originalGeomTransformed);   
                // this.textlength = jstsGeom.getLength();

                var projectService = new g2.sfs.CoordinateTransform();
                var measureService = new g2.sfs.MeasureService({ projectService: projectService });
                var length = measureService.length(this.lineEle.geometry);
                this.textlength = length;

                this.drawLayer.remove(this.bufferEle);
                //缓冲后geojson
                var geoJson = _getBufferGeoJson(this.geometry,this.textlength,this.map.spatialReference);
                this.bufferGeoJSON = geoJson;
                var polygonGeometry = g2.sfs.GeometryFactory.createGeometryFromGeoJson(geoJson, this.map.spatialReference);
                var ring = new g2.sfs.Ring({
                    spatialReference: this.map.spatialReference
                });
                polygonGeometry.addGeometry(ring);
                var fillSymbol = this.fillSymbol;
                this.bufferEle = new g2.sfs.Element({
                    geometry: polygonGeometry,
                    symbol: fillSymbol
                });
                this.drawLayer.add(this.bufferEle);

                //点的位置
                var arr = geoJson.coordinates;
                var list = this.parent._sortFunction(arr, geoJson.type);
                var point = new g2.sfs.Point({
                    x: list[0][0],
                    y: list[0][1],
                    spatialReference: this.map.spatialReference
                })
                //this.currentElement.geometry.x = mapx;
                //this.currentElement.geometry.y = this.bufferMaxPoint.y;
                this.currentElement.geometry = point;
                this.drawLayer.update(this.currentElement);
                //画线处理
                var polyline1 = new g2.sfs.Polyline({
                    spatialReference: this.map.spatialReference
                });
                var path1 = new g2.sfs.Path({
                    spatialReference: this.map.spatialReference
                });
                path1.addPoint(point1);
                path1.addPoint(point);
                polyline1.addGeometry(path1);
                this.lineEle.geometry = polyline1;
                this.drawLayer.update(this.lineEle);
                this.drawLayer.update(this.closeEle);
                //文字
                //this.textlength = jstsGeom.getLength();
                this.textlength = length;
                var textSymbol =this.textEle.symbol;
                if (!textSymbol) {
                    textSymbol = new g2.sfs.TextSymbol({
                        text: text,
                        foreground: new g2.sfs.Color({r: 255, g: 0, b: 0, a: 255}),
                        offsetX: 10,
                        offsetY: -13,
                        rotation: 0
                    });
                }
                this.drawLayer.remove(this.textEle);
                var text = Math.round(this.textlength) / 1000 + "km";
                textSymbol.text = text;
                //确定标注文字位置，默认middle
                var _geom = polyline1;
                if (this.textPosition=="middle") {
                    var _geom = polyline1
                }else if(this.textPosition=="left"){
                    var _geom = point1
                }else if(this.textPosition=="right"){
                    var _geom = point
                }
                this.textEle = new g2.sfs.Element({geometry: _geom, symbol: textSymbol});
                this.drawLayer.add(this.textEle);
                this.onMove++;
            }
        }
    },
    onMouseClick: function (button, shift, screenx, screeny, mapx, mapy, handled) {

    }
});
module.exports = BufferDragTool;